import { forwardRef } from 'react';
import { Button, ButtonProps } from '@/components/ui/button';
import { cn } from '@/lib/utils';

const SuccessButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, ...props }, ref) => (
    <Button
      ref={ref}
      className={cn(
        'bg-emerald border border-emerald/50 hover:bg-emerald/80 disabled:bg-primary/40 disabled:border-0',
        className
      )}
      {...props}
    />
  )
);
SuccessButton.displayName = 'SuccessButton';

export default SuccessButton;
